export const LEAD_RESULTS = [
  { value: 'all', display: 'All' },
  { value: 'sold', display: 'Sold' },
  { value: 'unsold', display: 'Unsold' }
];

export const SALES_TYPE = [
  { value: 'all', display: 'All' },
  { value: 'aggregator', display: 'Aggregator' },
  { value: 'agent', display: 'Agent' },
  { value: 'warranty', display: 'Warranty' }
];

export const USER_TYPES = [
  { value: 'all', display: 'Select Type' },
  { value: '1', display: 'Admin' },
  { value: '2', display: 'External Affiliate' },
  { value: '3', display: 'Agent' },
  { value: '4', display: 'Internal Affiliate' },
  { value: '5', display: 'Accounting' },
  { value: '6', display: 'Affiliate Manager' },
  { value: '7', display: 'Tech' },
  { value: '8', display: 'Power User' },
  { value: '9', display: 'AMB' },
  { value: '10', display: 'Remarketing' },
  { value: '11', display: 'Ops' },
  { value: '12', display: 'Internal Native Affiliate' },
  { value: '13', display: 'Click Buyer' }
];

export const PIXEL_TYPES = [
  { value: '-1', display: 'Select Pixel Type' },
  { value: 'iframe', display: 'iFrame' },
  { value: 'postback', display: 'Postback' },
  { value: 'js_script', display: 'JS Script' },
  { value: 'img', display: 'Image' }
];

export const PIXEL_LOCATION = [
  { value: '-1', display: 'Select Pixel Location' },
  { value: 'anywhere', display: 'Anywhere' },
  { value: 'head', display: 'Head' },
  { value: 'body', display: 'Body' }
];

export const PIXEL_STEP = [
  { value: '-1', display: 'Select Pixel Step' },
  { value: 'presell', display: 'Presell' },
  { value: 'form', display: 'Form' },
  { value: 'ty', display: 'Thank You' },
  { value: 'ty_click', display: 'Thank You Click' }
];

export const SPEND_STEP = [
  { value: '0', display: 'Select Step' },
  { value: 'landing', display: 'Landing' },
  { value: 'form', display: 'Form' },
  { value: 'quotes', display: 'Quotes' },
  { value: 'ma_click', display: 'Media Alpha Click' }
];

export const ASSET_TYPES = [
  { value: 'all', display: 'Select Asset Type' },
  { value: 'logo', display: 'Logo' },
  { value: 'background_image', display: 'Background Image' },
  { value: 'header', display: 'Header Text' },
  { value: 'call_to_action', display: 'Call to Action Text' }
];

export const ASSET_TYPES_PRESELL = [
  { value: 'all', display: 'Select Asset Type' },
  { value: 'top_image', display: 'Top Image' },
  { value: 'side_image', display: 'Side Image' },
  { value: 'bottom_image', display: 'Bottom Image' },
  { value: 'header', display: 'Header Text' },
  { value: 'call_to_action', display: 'Call to Action Text' }
];

export const ASSET_LOCATIONS = [
  { value: 'landing', display: 'Landing' },
  { value: 'presell', display: 'Presell' }
];

export const CAMPAIGN_STATUSES = [
  { value: 'all', display: 'All' },
  { value: 'active', display: 'Active' },
  { value: 'inactive', display: 'Inactive' }
];
export const CAMPAIGN_NETWORKS = [
  { value: '-1', display: 'All Networks' },
  { value: 'taboola', display: 'Taboola' },
  { value: 'outbrain', display: 'Outbrain' }
];

export const DEVICES = [
  { value: 'all', display: 'All devices' },
  { value: 'mobile', display: 'Mobile' },
  { value: 'desktop', display: 'Desktop' }
];

export const DEVICES_WITH_TABLET = [
  { value: 'all', display: 'All devices' },
  { value: 'phone', display: 'Phone' },
  { value: 'desktop', display: 'Desktop' },
  { value: 'tablet', display: 'Tablet' },
  { value: 'other', display: 'Other' }
];

export const AFFILIATE_INTERNAL_TYPE_OPTIONS = [
  { value: 'all', display: 'All Affiliates' },
  { value: 'internal', display: 'Internal' },
  { value: 'external', display: 'External' }
];

export const DEVICES_WITH_OTHER = [
  {
    id: '1',
    display_name: 'Desktop'
  },
  {
    id: '4',
    display_name: 'Other'
  },
  {
    id: '2',
    display_name: 'Phone'
  },
  {
    id: '3',
    display_name: 'Tablet'
  }
];

export const DEVICE_OPTIONS = [
  { value: 'all', display: 'All devices' },
  { value: '1', display: 'Desktop' },
  { value: '2', display: 'Mobile' },
  { value: '3', display: 'Tablet' },
  { value: '4', display: 'Other' }
];

export const DEVICE_OPTIONS_MAP = DEVICE_OPTIONS.reduce(
  (acc, { value, display }) => {
    return { ...acc, [value]: display };
  },
  {}
);

export const PLACEMENT_SOURCES = [
  { value: 'all', display: 'All' },
  { value: 'ty', display: 'TY' },
  { value: 'lb', display: 'LB' }
];

export const FORM_DATA_OPTIONS = [
  { value: 'all', display: 'All Forms' },
  { value: '0', display: 'Full Data Forms' },
  { value: '1', display: 'Partial Data Forms' }
];

export const INSURANCE_OPTIONS = [
  { value: '1', display: 'Insured' },
  { value: '0', display: 'Uninsured' }
];

export const YES_NO_OPTIONS = [
  { value: '1', display: 'Yes' },
  { value: '0', display: 'No' }
];

export const OWNERSHIP_OPTIONS = [
  { value: '1', display: 'Yes' },
  { value: '0', display: 'No' }
];

export const VEHICLE_OPTIONS = [
  { value: '1', display: 'Multiple driver/vehicle' },
  { value: '0', display: 'One driver/vehicle' }
];

export const MULTI_VEHICLE_OPTIONS = [
  { value: 0, display: 'Single Vehicle' },
  { value: 1, display: 'Multiple Vehicle' }
];

export const MULTI_DRIVER_OPTIONS = [
  { value: 0, display: 'Single Driver' },
  { value: 1, display: 'Multiple Driver' }
];

export const AGE_GROUP_OPTIONS = [
  { display: 'Under 21', value: 1 },
  { display: '21-25', value: 2 },
  { display: '26-30', value: 3 },
  { display: '31-35', value: 4 },
  { display: '36-40', value: 5 },
  { display: '41-45', value: 6 },
  { display: '46-50', value: 7 },
  { display: '51-55', value: 8 },
  { display: '56-60', value: 9 },
  { display: '61-65', value: 10 },
  { display: '66-70', value: 11 },
  { display: '71-75', value: 12 },
  { display: '76-80', value: 13 },
  { display: '81-85', value: 14 },
  { display: '86-90', value: 15 },
  { display: '91-95', value: 16 },
  { display: '96+', value: 17 }
];

export const CREDIT_RATING_OPTIONS = [
  { display: 'Poor', value: 1 },
  { display: 'Average', value: 3 },
  { display: 'Good', value: 4 },
  { display: 'Excellent', value: 5 }
];

export const STATES_OPTIONS_ABBR = [
  { display: 'All', value: 'all' },
  { display: 'Alabama', value: 'AL' },
  { display: 'Alaska', value: 'AK' },
  { display: 'Arizona', value: 'AZ' },
  { display: 'Arkansas', value: 'AR' },
  { display: 'California', value: 'CA' },
  { display: 'Colorado', value: 'CO' },
  { display: 'Connecticut', value: 'CT' },
  { display: 'Delaware', value: 'DE' },
  { display: 'District of Columbia', value: 'DC' },
  { display: 'Florida', value: 'FL' },
  { display: 'Georgia', value: 'GA' },
  { display: 'Hawaii', value: 'HI' },
  { display: 'Idaho', value: 'ID' },
  { display: 'Illinois', value: 'IL' },
  { display: 'Indiana', value: 'IN' },
  { display: 'Iowa', value: 'IA' },
  { display: 'Kansas', value: 'KS' },
  { display: 'Kentucky', value: 'KY' },
  { display: 'Louisiana', value: 'LA' },
  { display: 'Maine', value: 'ME' },
  { display: 'Maryland', value: 'MD' },
  { display: 'Massachusetts', value: 'MA' },
  { display: 'Michigan', value: 'MI' },
  { display: 'Minnesota', value: 'MN' },
  { display: 'Mississippi', value: 'MS' },
  { display: 'Missouri', value: 'MO' },
  { display: 'Montana', value: 'MT' },
  { display: 'Nebraska', value: 'NE' },
  { display: 'Nevada', value: 'NV' },
  { display: 'New Hampshire', value: 'NH' },
  { display: 'New Jersey', value: 'NJ' },
  { display: 'New Mexico', value: 'NM' },
  { display: 'New York', value: 'NY' },
  { display: 'North Carolina', value: 'NC' },
  { display: 'North Dakota', value: 'ND' },
  { display: 'Ohio', value: 'OH' },
  { display: 'Oklahoma', value: 'OK' },
  { display: 'Oregon', value: 'OR' },
  { display: 'Pennsylvania', value: 'PA' },
  { display: 'Rhode Island', value: 'RI' },
  { display: 'South Carolina', value: 'SC' },
  { display: 'South Dakota', value: 'SD' },
  { display: 'Tennessee', value: 'TN' },
  { display: 'Texas', value: 'TX' },
  { display: 'Utah', value: 'UT' },
  { display: 'Vermont', value: 'VT' },
  { display: 'Virginia', value: 'VA' },
  { display: 'Washington', value: 'WA' },
  { display: 'West Virginia', value: 'WV' },
  { display: 'Wisconsin', value: 'WI' },
  { display: 'Wyoming', value: 'WY' }
];

export const STATES_OPTIONS_ABBR_NO_DC = [
  { display: 'All', value: 'all' },
  { display: 'Alabama', value: 'AL' },
  { display: 'Alaska', value: 'AK' },
  { display: 'Arizona', value: 'AZ' },
  { display: 'Arkansas', value: 'AR' },
  { display: 'California', value: 'CA' },
  { display: 'Colorado', value: 'CO' },
  { display: 'Connecticut', value: 'CT' },
  { display: 'Delaware', value: 'DE' },
  { display: 'Florida', value: 'FL' },
  { display: 'Georgia', value: 'GA' },
  { display: 'Hawaii', value: 'HI' },
  { display: 'Idaho', value: 'ID' },
  { display: 'Illinois', value: 'IL' },
  { display: 'Indiana', value: 'IN' },
  { display: 'Iowa', value: 'IA' },
  { display: 'Kansas', value: 'KS' },
  { display: 'Kentucky', value: 'KY' },
  { display: 'Louisiana', value: 'LA' },
  { display: 'Maine', value: 'ME' },
  { display: 'Maryland', value: 'MD' },
  { display: 'Massachusetts', value: 'MA' },
  { display: 'Michigan', value: 'MI' },
  { display: 'Minnesota', value: 'MN' },
  { display: 'Mississippi', value: 'MS' },
  { display: 'Missouri', value: 'MO' },
  { display: 'Montana', value: 'MT' },
  { display: 'Nebraska', value: 'NE' },
  { display: 'Nevada', value: 'NV' },
  { display: 'New Hampshire', value: 'NH' },
  { display: 'New Jersey', value: 'NJ' },
  { display: 'New Mexico', value: 'NM' },
  { display: 'New York', value: 'NY' },
  { display: 'North Carolina', value: 'NC' },
  { display: 'North Dakota', value: 'ND' },
  { display: 'Ohio', value: 'OH' },
  { display: 'Oklahoma', value: 'OK' },
  { display: 'Oregon', value: 'OR' },
  { display: 'Pennsylvania', value: 'PA' },
  { display: 'Rhode Island', value: 'RI' },
  { display: 'South Carolina', value: 'SC' },
  { display: 'South Dakota', value: 'SD' },
  { display: 'Tennessee', value: 'TN' },
  { display: 'Texas', value: 'TX' },
  { display: 'Utah', value: 'UT' },
  { display: 'Vermont', value: 'VT' },
  { display: 'Virginia', value: 'VA' },
  { display: 'Washington', value: 'WA' },
  { display: 'West Virginia', value: 'WV' },
  { display: 'Wisconsin', value: 'WI' },
  { display: 'Wyoming', value: 'WY' }
];

export const STATES_OPTIONS = [
  { display: 'Unknown', value: 0 },
  { display: 'Alabama', value: 1 },
  { display: 'Alaska', value: 2 },
  { display: 'Arizona', value: 3 },
  { display: 'Arkansas', value: 4 },
  { display: 'California', value: 5 },
  { display: 'Colorado', value: 6 },
  { display: 'Connecticut', value: 7 },
  { display: 'Delaware', value: 8 },
  { display: 'District of Columbia', value: 9 },
  { display: 'Florida', value: 10 },
  { display: 'Georgia', value: 11 },
  { display: 'Hawaii', value: 12 },
  { display: 'Idaho', value: 13 },
  { display: 'Illinois', value: 14 },
  { display: 'Indiana', value: 15 },
  { display: 'Iowa', value: 16 },
  { display: 'Kansas', value: 17 },
  { display: 'Kentucky', value: 18 },
  { display: 'Louisiana', value: 19 },
  { display: 'Maine', value: 20 },
  { display: 'Maryland', value: 21 },
  { display: 'Massachusetts', value: 22 },
  { display: 'Michigan', value: 23 },
  { display: 'Minnesota', value: 24 },
  { display: 'Mississippi', value: 25 },
  { display: 'Missouri', value: 26 },
  { display: 'Montana', value: 27 },
  { display: 'Nebraska', value: 28 },
  { display: 'Nevada', value: 29 },
  { display: 'New Hampshire', value: 30 },
  { display: 'New Jersey', value: 31 },
  { display: 'New Mexico', value: 32 },
  { display: 'New York', value: 33 },
  { display: 'North Carolina', value: 34 },
  { display: 'North Dakota', value: 35 },
  { display: 'Ohio', value: 36 },
  { display: 'Oklahoma', value: 37 },
  { display: 'Oregon', value: 38 },
  { display: 'Pennsylvania', value: 39 },
  { display: 'Rhode Island', value: 40 },
  { display: 'South Carolina', value: 41 },
  { display: 'South Dakota', value: 42 },
  { display: 'Tennessee', value: 43 },
  { display: 'Texas', value: 44 },
  { display: 'Utah', value: 45 },
  { display: 'Vermont', value: 46 },
  { display: 'Virginia', value: 47 },
  { display: 'Washington', value: 48 },
  { display: 'West Virginia', value: 49 },
  { display: 'Wisconsin', value: 50 },
  { display: 'Wyoming', value: 51 }
];

export const STATES_ABBREVIATION = {
  0: 'Unknown',
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming'
};

export const optionsFromStatesAbbreviation = Object.entries(
  STATES_ABBREVIATION
).map(([abbreviation, display]) => ({
  value: abbreviation,
  display
}));

export const STATES_OPTIONS_WITHOUT_UNKNOWN =
  optionsFromStatesAbbreviation.filter((option) => option.value !== '0');

export const PRESETS_OPTIONS = [
  { value: '0', display: 'Select a preset' },
  { value: '5', display: 'No preset' },
  {
    value: '1',
    display:
      'Multiple driver/vehicle, insured, homeowner, above average credit, ages between 21 and 65'
  },
  {
    value: '2',
    display:
      'Multiple driver/vehicle, insured, homeowner, above average credit, ages under 21 and over 65'
  },
  { value: '3', display: 'Uninsured, renter, below average credit' },
  {
    value: '4',
    display: '1 driver/vehicle, insured, homeowner, above average credit'
  }
];

export const EXCLUDE_BUYER_TYPE_OPTIONS = [
  { value: 0, display: 'All Types' },
  { value: 1, display: 'Exclude TY, Leave Behind, and Phone' },
  { value: 2, display: 'Exclude Aggregators and Ping Tree' },
  { value: 3, display: 'Exclude TY and Leave Behind' }
];

export const TIME_PEAK_OPTIONS = [
  { value: 'all', display: 'All' },
  { value: 'peak', display: 'Peak (9AM - 5PM EST)' },
  { value: 'off_peak', display: 'Off Peak (5PM - 9AM EST)' }
];

export const PROVIDER_TYPES = [
  { value: 'all', display: 'All' },
  { value: 'sms', display: 'SMS' },
  { value: 'email', display: 'Email' }
];

export const COST_TYPES = [
  { value: 'affiliate', display: 'Affiliate Level' },
  { value: 's1', display: 'S1 Level' }
];
